import React from 'react';
import PropTypes from 'prop-types';

const ButtonIcon = ({buttonClass, iconClass, description}) => {
	return (
		<button className={buttonClass} title={description} >
			<i className={iconClass} />
		</button>
	);
};

ButtonIcon.propTypes = {
    
};

export default ButtonIcon;
